import { RepositoryFactory } from "../../repository/RepositoryFactory";
var sendEmail = RepositoryFactory.get("sendEmail");
export const sendContactEmail = (detail, onSuccess) => async (dispatch) => {
    dispatch(getLoader(true));
    try {
        const { data } = await sendEmail.sendEmailRepo(detail);
        if (data.success) {
            dispatch(getLoader(false));
            setTimeout(() => {
                alert(data.message);
                onSuccess();
            }, 0);
        } else {
            dispatch(getLoader(false));
        }
    } catch (error) {
        dispatch(getLoader(false));
    }
};
const getLoader = (data) => async (dispatch) => {
    dispatch({
        type: "LOADER",
        payload: data,
    });
};
